
import { httpservice } from '../services';
import { dateFormat } from '../helper/StringUtils';
import { constants } from '../constant/constant';
import {SOFTWARE, EMOTION} from '../constant/actionTypes';

export default object => dispatch => {
  let query = constants.API.EMOTION;
  if (object && object.id) {
    query = `${constants.API.EMOTION}/${object.id}`;
  } else if (object && Object.keys(object).length > 0) {
    // Build query string for other properties
    const params = new URLSearchParams(object).toString();
    query = `${constants.API.EMOTION}?${params}`;
  }
  dispatch({
    payload: [],
    type: EMOTION.GET.INITIATE
  });
  return httpservice()
    .get(query)
    .then(response => {
      const { rows = [], count = 0 } = response.data.response;
      // let softwareIdArray = [];
      const responseData = rows.map(data => {
      //   if (data.clientId) {
      //     if (softwareIdArray.includes(data.softwareId)) {
      //       return;
      //     } else {
      //       softwareIdArray.push(data.softwareId);
      //       return {
      //         id: data.softwareId,
      //         submoduleId: data.submoduleId,
      //         name: data.software.name,
      //         description: data.software.description,
      //         guid: data.software.guid,
      //         type: data.software.type,
      //         clientId: data.software.clientId,
      //         created_at: dateFormat(data.software.createdAt),
      //         createdBy: data.software.creator
      //           ? data.software.creator['firstName'] + ' ' + data.software.creator['lastName']
      //           : 'admin'
      //       };
      //     }
      //   } else {
      //     data.isPublicKey = data.isPublicKey ? 'Available' : 'Not Available';
          data.created_at = data.createdAt; // keep ISO string; formatted in the table render
          data.created_by = data.creator ? data.creator.firstName + ' ' + data.creator.lastName : 'admin';
      //     data.subModuleId = null;
          return data;
        // }
      });

      const dataArray = responseData.filter(element => typeof element !== 'undefined');
      const respObject = { data: dataArray, count: count }
      dispatch({
        payload: respObject,
        type: EMOTION.DATA.SUCCESS
      });
      return respObject;
    })
    .catch(function(error) {
      dispatch({
        payload: error,
        type: EMOTION.DATA.ERROR
      });
    });
};
